export const vinRegex = /^[A-HJ-NPR-Z0-9]{17}$/;
